import { Node, mergeAttributes } from '@tiptap/core';

// a hard page break: the PDF starts the following content on a fresh page
export const PageBreakNode = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'div[data-page-break]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-page-break': '', class: 'agreement-page-break' }),
      'Page break',
    ];
  },
});
